"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.logger = exports.loggerPrefix = void 0;
const pino_1 = require("pino");
exports.loggerPrefix = '[Eppo SDK]';
// Create a Pino logger instance
exports.logger = (0, pino_1.default)({
    // eslint-disable-next-line no-restricted-globals
    level: process.env.LOG_LEVEL ?? (process.env.NODE_ENV === 'production' ? 'warn' : 'info'),
    // https://getpino.io/#/docs/browser
    browser: { disabled: true },
});
//# sourceMappingURL=application-logger.js.map